import type { ReactNode } from 'react'

import { Container } from './Container'

type Props = {
	children: ReactNode
}

export const OrderedList = ({ children }: Props) => <Container>{children}</Container>
